// extracted by mini-css-extract-plugin
export default {"diyRecipeList":"u59sa0","diyRecipeListStack":"MOXtuC","ellipse":"XMeEOh"};